
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { LedgerPostModel } from './Entities.Accounting.LedgerPost';
import { Model, ModelProperty } from 'models/Model';


export class BillingPlanDtoModel extends Model<BillingPlanDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'accountingPlanId', type: 'string' },
		{ name: 'expectedTotalValue', type: 'number' },
		{ name: 'ledgerPosts', type: 'LedgerPostModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new LedgerPostModel }, properties: () => { return LedgerPostModel.classProperties } }
	];
	[key: string]: any;
	
	public accountingPlanId?: string;
	public expectedTotalValue: number;
	public ledgerPosts: LedgerPostModel[];
    
	constructor(){
		super();
		this.accountingPlanId = undefined;
		this.expectedTotalValue = 0;
		this.ledgerPosts = [];
		
	}
	getProperties(){
		return BillingPlanDtoModel.classProperties;
	}
}

